<template>
  <div @click="handleClick">
    <span class="index" :style="'background-color: ' + color">
      {{ $gettext(text) }}
    </span>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'invoice-situation',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
})
export default class InvoiceSituation extends Vue {
  handleClick () {
    this.$emit('clickAction', this.text)
  }
}
</script>
<style scoped>
  .index {
    border-radius: 25px;
    padding: 4px 14px;
    max-height: 25px;
    white-space: nowrap;
    cursor: pointer;
  }
</style>
